import { Box, Divider, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface AssessmentOverallScoreProps {
    overall: number;
    pronunciation: number;
    tone: number;
    initial: number;
    vowel: number;
    fluency: number;
}

export const AudioAssessmentOverallScore: React.FC<AssessmentOverallScoreProps> = ({ overall, pronunciation, initial, tone, vowel, fluency }) => {
    const { t } = useTranslation();
    return (
        <Paper
            sx={{
                p: 2,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
            }}
        >
            {/* Overall Score Section */}
            <Box sx={{ mb: 3 }}>
                <Typography
                    variant='body1'
                    sx={{
                        fontWeight: 500,
                        mb: 1,
                    }}
                >
                    {t('assessment.audio.overall')}
                </Typography>
                <Typography
                    variant='h2'
                    sx={{
                        color: 'primary.main',
                        fontWeight: 'bold',
                        fontSize: '3rem',
                        lineHeight: 1,
                    }}
                >
                    {overall < 0 ? '-' : Math.floor(overall)}
                </Typography>
            </Box>

            <Divider />

            {/* Detailed Scores Section */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(5, 1fr)',
                    gap: 2,
                    pt: 2,
                }}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant='body2'
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            display: 'block',
                            mb: 0.5,
                        }}
                    >
                        {t('assessment.audio.pronunciation')}
                    </Typography>
                    <Typography
                        variant='h6'
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                        }}
                    >
                        {pronunciation < 0 ? '-' : Math.floor(pronunciation)}
                    </Typography>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant='body2'
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            display: 'block',
                            mb: 0.5,
                        }}
                    >
                        {t('assessment.audio.tone')}
                    </Typography>
                    <Typography
                        variant='h6'
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                        }}
                    >
                        {tone < 0 ? '-' : Math.floor(tone)}
                    </Typography>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant='body2'
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            display: 'block',
                            mb: 0.5,
                        }}
                    >
                        {t('assessment.audio.initial')}
                    </Typography>
                    <Typography
                        variant='h6'
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                        }}
                    >
                        {initial < 0 ? '-' : Math.floor(initial)}
                    </Typography>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant='body2'
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            display: 'block',
                            mb: 0.5,
                        }}
                    >
                        {t('assessment.audio.vowel')}
                    </Typography>
                    <Typography
                        variant='h6'
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                        }}
                    >
                        {vowel < 0 ? '-' : Math.floor(vowel)}
                    </Typography>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant='body2'
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            display: 'block',
                            mb: 0.5,
                        }}
                    >
                        {t('assessment.audio.fluency')}
                    </Typography>
                    <Typography
                        variant='h6'
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                        }}
                    >
                        {fluency < 0 ? '-' : Math.floor(fluency)}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};
